// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1yBIh","boxTitle":"Qualiphy_boxTitle__sGC10","box":"Qualiphy_box__2VLaf","toggleWrap":"Qualiphy_toggleWrap__3SI7x"};